import "./styles.css";

const termChallengePage = () => {
  return (
    <div class="about-section">
      <h4>
        Syarat & Ketentuan – Challenge Program One Day One Juz ( Tantangan
        Harian Juz )
      </h4>
      <p class="line-space">
        Program ini bertujuan untuk menjaga kita selalu berinteraksi dan
        Istiqomah setiap hari membaca Al- Quran <b>satu hari satu Juz</b>
      </p>
      <span>1. Peserta harus join challenge – Program One Day One Juz</span>
      <p></p>
      <span>
        2. Peserta menyelesaikan program khatam baca Al-Quran ( tanggal mulai
        dan berakhir sesuai ketentuan yg sudah ditetapkan)
      </span>
      <p></p>
      <span>
        3. Peserta melakukan tilawah / membaca Al-Quran hanya di Aplikasi Diary
        Muslim
      </span>
      <p></p>
      <span>
        4. Tilawah Al-Quran dilakukan setiap hari dan berurutan dimulai dari
        hari 1 ( Day-1) dari juz 1 sampai dengan hari 30 (Day-30) Juz 30.
      </span>
      <p></p>
      <span>
        5. Peserta yang bisa menyelesaikan sesuai target akan mendapat Badge dan
        Poin
      </span>
      <p></p>
      <span>6. Badge Program yang ditampilkan di user profile :</span>
      <ul>
        <li>
          Badge Emas = untuk peserta yang selesai membaca 30 Juz dan sesuai
          aturan waktu yang ditetapkan yaitu satu hari satu juz
        </li>
        <li>
          Badge Perak = untuk peserta yang selesai membaca 30 Juz tapi tidak
          sesuai target waktu yang ditentukan , misalnya : Membaca Al-Quran 30
          juz tapi hanya dalam 10 hari
        </li>
      </ul>
      <p></p>
      <span>
        7. Jumlah poin yang didapat akan dihitung berdasarkan kehadiran mengaji
        per hari-nya, Perhitungan poin misalnya seperti berikut :
        <div style={{ marginLeft: 80, marginTop: 8 }}>
          1 hari = 1 juz = 10 poin
        </div>
        <div style={{ marginLeft: 80 }}>
          contoh : 30 hari x 10 = 300 poin ; 10 hari x 10 = 100 poin
        </div>
      </span>
      <p></p>
      <span>8. Penukaran poin akan diinformasikan jadwalnya kemudian.</span>
      <br />
      <br />
      <h4>
        Syarat & Ketentuan – Challenge Verse per Day (Tantangan Harian Ayat)
      </h4>
      <p class="line-space">
        Program ini bertujuan untuk menjaga kita selalu berinteraksi dan
        Istiqomah setiap hari membaca Al- Quran Satu Hari Satu Ayat
      </p>
      <span>1. Peserta harus join challenge – Program One Day One Verse</span>
      <p></p>
      <span>
        2. Peserta melakukan tilawah / membaca Al-Quran hanya di Aplikasi Diary
        Muslim
      </span>
      <p></p>
      <span>
        3. Tilawah Al-Quran dilakukan setiap hari dan berurutan dimulai dari
        hari-1 ( Day-1).
      </span>
      <p></p>
      <span>
        4. Peserta yang bisa menyelesaikan sesuai target akan mendapat Badge dan
        Poin
      </span>
      <p></p>
      <span>5. Badge Program yang ditampilkan di user profile :</span>
      <ol type="1">
        <li>
          Badge Emas = untuk peserta yang selesai membaca full 100% sesuai
          periode program tanpa absen
        </li>
        <li>
          Badge Perak = untuk peserta yang selesai membaca 50% target sesuai
          periode program
        </li>
      </ol>
      <p></p>
      <span>
        6. Jumlah poin yang didapat akan dihitung berdasarkan kehadiran mengaji
        per hari-nya, Perhitungan poin seperti berikut :
        <div style={{ marginLeft: 50, marginTop: 8 }}>
          1 hari = 1 ayat = 1 poin
        </div>
        <div style={{ marginLeft: 50 }}>
          Jika, 30 hari hadir membaca x 1 = 30 poin ; 10 hari hadir membaca x 1
          = 10 poin
        </div>
      </span>
      <p></p>
      <span>7. Penukaran poin akan diinformasikan jadwalnya kemudian.</span>
      <br />
      <br />
      <h4>
        Syarat & Ketentuan – Challenge Surah per Day (Tantangan Harian Surat )
      </h4>
      <p class="line-space">
        Program ini bertujuan untuk menjaga kita selalu berinteraksi dan
        Istiqomah setiap hari membaca Al- Quran dengan mengulang-ulang surat
        harian untuk terus mendekatkan diri pada Allah swt dan senantiasa berdoa
        keridhaan dan keberkahan dari ayat-ayat Al-Quran yang kita baca.
      </p>
      <span>1. Peserta harus join challenge – One Day 4 Surah</span>
      <p></p>
      <span>
        2. Peserta melakukan tilawah / membaca Al-Quran hanya di Aplikasi Diary
        Muslim
      </span>
      <p></p>
      <span>
        3. Tilawah Al-Quran dilakukan setiap hari dan berurutan dimulai dari
        hari-1 ( Day-1).
      </span>
      <p></p>
      <span>
        4. Peserta yang bisa menyelesaikan sesuai target akan mendapat Badge dan
        Poin
      </span>
      <p></p>
      <span>5. Badge Program yang ditampilkan di user profile:</span>
      <ol type="a">
        <li>
          Badge Emas = untuk peserta yang selesai membaca full 100% sesuai
          periode program tanpa absen
        </li>
        <li>
          Badge Perak = untuk peserta yang selesai membaca 50% dari target
          sesuai periode program
        </li>
      </ol>
      <p></p>
      <span>
        6. Jumlah poin yang didapat akan dihitung berdasarkan kehadiran mengaji
        per hari-nya Perhitungan poin seperti berikut :
        <div style={{ marginLeft: 50, marginTop: 8 }}>
          1 hari = 4 Surat (QS Yasin, Ar-rahman, Alwaqiah, Al-Mulk) = 10 poin
        </div>
        <div style={{ marginLeft: 50 }}>
          Jika , 30 hari hadir membaca x 10= 300 poin ; 10 hari hadir membaca x
          10 = 100 poin
        </div>
      </span>
      <p></p>
      <span>7. Penukaran poin akan diinformasikan jadwalnya kemudian.</span>
    </div>
  );
};

export default termChallengePage;
